import { useState, useEffect, useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MatchedBet from "../../components/MatchedBet";
import BettingSlip from "../../components/BettingSlip";
// import { getGreyhoundRaceOdds } from "../../api";
// import { updateParticularOdds } from "../../redux/slices/greyhoundSlice";

const Market = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const marketId = searchParams.get("marketId");
  const raceName = searchParams.get("raceName");
  // const [gOdds, setGodds] = useState({});
  const [newData, setNewData] = useState(null);

  const { bets } = useSelector((state) => state?.account);

  const filteredBets = bets?.filter(
    (bet) => bet.matchId === marketId && bet.markettype === "Greyhound Odds"
  );

  const odd = useSelector(state =>
    state?.greyhound?.greyHoundMarkets?.find(ghm => ghm.marketId === marketId)
  );

  useEffect(() => {
    setNewData(
      {
        type: "Back",
        selection: 80990525,
        selectionId: 80990525,
        oddsReq: 12,
        eventType: marketId,
        eventId: marketId,
        legueId: marketId,
        marketId: marketId,
        joinedMarketIds: marketId,
        matchId: marketId,
        sportId: marketId,
        market: "Greyhound Odds",
        markettype: "Greyhound Odds",
        runners: [
          {
            "selectionId": 2277370,
            "runnerName": "Tolima",
            "handicap": 0,
            "sortPriority": 1
          },
          {
            "selectionId": 6563307,
            "runnerName": "Llaneros FC",
            "handicap": 0,
            "sortPriority": 2
          },
          {
            "selectionId": 58805,
            "runnerName": "The Draw",
            "handicap": 0,
            "sortPriority": 3
          }
        ],
        sportsName: "Greyhound Odds",
        runnersCount: 0
      }
    )
  }, []);

  const [selectedBet, setSelectedBet] = useState(null);
  const [localBetData, setLocalBetData] = useState(null);
  const [betType, setBetType] = useState(null);
  const [index, setIndex] = useState(null);
  const [matchIndex, setMatchIndex] = useState(null);



  const handleDataClick = useCallback((runnerName, odds, type, runnerData, idx, currentMatchIndex) => {
    const oddsData = {
      oddsType: type,
      odds,
      selectionId: runnerData.selectionId,
      runnerName,
    };

    setBetType(type);
    setIndex(idx);
    setMatchIndex(currentMatchIndex);
    setLocalBetData(oddsData);
    setSelectedBet(true);
  }, []);


  return (
    <>
      <section className="overflow-y-scroll">
        <div className="w-full max-w-screen-xl flex flex-col bg-gray-100 ods-container-mob">
          <div className=" bg-[#18adc5] flex justify-between items-center text-secondary match-header-mob">
            <div>
              <h3 className="font-bold sm:p-2 text-xs">{raceName}</h3>
            </div>
          </div>
          <div className="mobils-ods-head">
            <div className="mobils-ods-min">Min: 0.00 | Max: 0.00</div>
            <div className="asian-ods-btn">
              <button>Back</button>
              <button>Lay</button>
            </div>
          </div>
          <div className="bg-white rounded-b-md overflow-hidden">
            <table className="odds-table odds-table-asian">
              <thead className="head-hide-mobile">
                <tr>
                  <th className="section-head"></th>
                  <th className="market-top-head"></th>
                  <th className="market-top-head"></th>
                  <th className="market-top-head" style={{ padding: "0px" }}>
                    <div className="back-header">Back All</div>
                  </th>
                  <th className="market-top-head" style={{ padding: "0px" }}>
                    <div className="lay-header">Lay All</div>
                  </th>
                  <th className="market-top-head"></th>
                  <th className="market-top-head market-top-head-last"></th>
                </tr>
              </thead>
              {/* <tbody>
                {gOdds?.runners?.map((runner, idx) => {

                  const runnerId = runner?.selectionId;
                  let placedBetCalculation = 0;
                  const fbOfthisRunner = filteredBets?.filter(
                    (fb) =>
                      fb.selectionId.toString() ===
                      runner.selectionId.toString() &&
                      marketId.toString() === fb.matchId.toString()
                  );
                  fbOfthisRunner?.forEach((fbr) => {
                    const subject =
                      fbr.type === "Back" ? fbr.favourMargin : -fbr.againstMargin;
                    placedBetCalculation += subject;
                  });
                  const fbOfOtherRunners = filteredBets?.filter(
                    (fb) =>
                      fb.selectionId.toString() !==
                      runner.selectionId.toString() &&
                      marketId.toString() === fb.matchId.toString()
                  );
                  fbOfOtherRunners?.forEach((fbor) => {
                    const subject =
                      fbor.type === "Back"
                        ? -fbor.againstMargin
                        : fbor.favourMargin;
                    placedBetCalculation += subject;
                  });



                  return (
                    <tr key={idx} className="asian-full-market asian-full-market-other">
                      <td style={{ textAlign: "start" }}>
                        {runner.selectionId}
                        <br />

                        <span>
                          {filteredBets &&
                            filteredBets?.length > 0 &&
                            filteredBets[0].markettype === "Greyhound Odds" && (
                              <span
                                style={{
                                  fontSize: "12px",
                                  color:
                                    placedBetCalculation < 0
                                      ? "red"
                                      : "green",
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: "4px",
                                }}
                              >
                                <span
                                  style={{ marginRight: "2px" }}
                                  className="text-[14px]"
                                >
                                  {placedBetCalculation < 0 ? "-" : ""}
                                </span>
                                {Math.abs(placedBetCalculation)?.toFixed(0)}
                              </span>
                            )}
                        </span>

                      </td>
                      {[...Array(3)].map((_, i) => (
                        <td
                          key={`back-${i}`}
                          onClick={() => handleDataClick(runner.selectionId, runner?.ex?.availableToBack[i]?.price, "Back", runner, i, idx)}
                          className={`cursor-pointer asian-back${i}`}
                        >
                          {runner.ex.availableToBack[i]?.price || "-"} <br />
                          <span style={{ fontSize: "8px" }}>{runner.ex.availableToBack[i]?.size || "-"}</span>
                        </td>
                      ))}
                      {[...Array(3)].map((_, i) => (
                        <td
                          key={`lay-${i}`}
                          onClick={() => runner.status === "ACTIVE" && handleDataClick(runner.selectionId, runner?.ex?.availableToLay[i]?.price, "Lay", runner, i, idx)}
                          className={`cursor-pointer asian-lay${i}`}
                        >
                          {runner.ex.availableToLay[i]?.price || "-"} <br />
                          <span style={{ fontSize: "8px" }}>{runner.ex.availableToLay[i]?.size || "-"}</span>
                        </td>
                      ))}
                    </tr>
                  )
                })}

              </tbody> */}
            </table>
          </div>
        </div>

        {selectedBet && (
          <BettingSlip
            oddsData={localBetData}
            betType={betType}
            index={index}
            matchIndex={matchIndex}
            onCancel={() => setSelectedBet(null)}
            matchesData={[]}
            newData={newData}
            nodelay={true}
          />
        )}

      </section>



      <section>
        <MatchedBet />
      </section>
    </>
  );
};

export default Market;
